module.exports = __webpack_public_path__ + "static/cover-f36f05c4765650effc62f605a124ef33.jpg";